import "history";
import { PerxisService } from "../../../../shared/services/perxis/index.js";
import { getExtendedItems } from "../../../../shared/store/reference/lib/getExtendedItems.js";
import "@perxis-auto/shared";
import "../../../../shared/store/reference/model/index.js";
import "@perxis-auto/shared/lib/lib/instanceOf";
import { createRawFilterValuesItem } from "./create/createRawFilterValuesItem.js";
import { formatExtRawFilterValuesItem } from "./format/formatExtRawFilterValuesItem.js";
import { formatFilterValuesParameters } from "./format/formatFilterValuesParameters.js";
import { fetchFilterValuesWithExtraData } from "./fetchFilterValuesWithExtraData.js";
import { fetchFilterValuesWithExtraValues } from "./fetchFilterValuesWithExtraValues.js";
const fetchAllFilterValues = async (queryApi, parameters) => {
  const { itemsClient } = PerxisService.getInstance();
  const { result: data = {} } = await itemsClient.aggregatePublished(formatFilterValuesParameters(parameters));
  const rawFilterValuesItem = createRawFilterValuesItem(data, parameters);
  const [extRawFilterValuesItem] = await getExtendedItems(
    queryApi,
    [rawFilterValuesItem]
  );
  const formattedExtRawFilterValuesItem = formatExtRawFilterValuesItem(extRawFilterValuesItem);
  const rawFilterValuesWithExtraDataItem = await fetchFilterValuesWithExtraData(
    queryApi,
    formattedExtRawFilterValuesItem
  );
  const rawFilterValuesWithExtraDataAndValuesItem = await fetchFilterValuesWithExtraValues(
    queryApi,
    rawFilterValuesWithExtraDataItem
  );
  return rawFilterValuesWithExtraDataAndValuesItem;
};
export {
  fetchAllFilterValues
};
